import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';

declare global {
  interface Window {
    heap: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class SgHeapIoService {
  /** Heap IO API object */
  private heap: any;

  constructor(private env: EnvironmentService) {
    const heap = window.heap || [];
    heap.load = function (e, t) {
      (window.heap.appid = e), (window.heap.config = t = t || {});
      let r = document.createElement('script');
      r.type = 'text/javascript';
      (r.async = !0), (r.src = 'https://cdn.heapanalytics.com/js/heap-' + e + '.js');
      let a = document.getElementsByTagName('script')[0];
      a.parentNode.insertBefore(r, a);
      for (
        let n = function (e) {
            return function () {
              heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
          },
          p = [
            'addEventProperties',
            'addUserProperties',
            'clearEventProperties',
            'identify',
            'resetIdentity',
            'removeEventProperty',
            'setEventProperties',
            'track',
            'unsetEventProperty',
          ],
          o = 0;
        o < p.length;
        o++
      ) {
        heap[p[o]] = n(p[o]);
      }
    };
    window.heap = this.heap = heap;
  }

  load(appId: string) {
    if (this.heap) {
      this.heap.load(appId);
    } else {
      throw new Error('Heap IO is not initialized');
    }
  }

  identify(id: string) {
    if (this.heap) {
      this.heap.identify(id);
    } else {
      throw new Error('Heap IO is not initialized');
    }
  }

  addUserProperties(properties: { [name: string]: any }) {
    if (this.heap) {
      this.heap.trackUserProperties(properties);
    } else {
      throw new Error('Heap IO is not initialized');
    }
  }

  track(event_name: string, properties: { [name: string]: any }) {
    if (this.heap) {
      this.heap.track(event_name, properties);
    } else {
      throw new Error('Heap IO is not initialized');
    }
  }
}
